import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

export default function ManagementLayout({ children }) {
  return (
    <div className="mol-layout">
      <Sidebar />
      <div className="mol-layout__main">
        <Header />
        <main className="mol-layout__content">
          {children}
        </main>
      </div>
    </div>
  );
}
